import type { SearchMatches } from 'widgets/sports-menu-widget/model/types';

import { ResultGroup } from '../ResultGroup';

import { TXTWCL_Meetings } from './MeetingsResultGroup.messages.json';

interface Props {
  meetings: SearchMatches['competitions'];
}
export const MeetingsResultGroup = ({ meetings }: Props) => (
  <ResultGroup resultsGroup={meetings} titleTranslationTag={TXTWCL_Meetings} />
);
